<template>
  <div class="page-content">
    <header class="header">
      <div class="container header-content flex">
        <router-link class="logo" to="/">
          <svg class="svg-logo">
            <use href="/img/logo.svg#svg-logo"></use>
          </svg>
        </router-link>
        <div class="header-column flex">
          <!--NAVIGATION-->
          <div class="nav-list-wrapper scroll-x">
            <ul class="nav-list flex">
              <router-link to="/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.orders') }}</a>
                </li>
              </router-link>

              <router-link to="/position/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.ordersExpanded') }}</a>
                </li>
              </router-link>

              <router-link v-if="user.role==='admin'" to="/order/add/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.addOrder') }}</a>
                </li>
              </router-link>

              <router-link v-if="user.role==='admin'" to="/users/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.users') }}</a>
                </li>
              </router-link>

              <router-link v-if="user.role==='admin'" to="/user/add/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.addUser') }}</a>
                </li>
              </router-link>

              <router-link to="/help/" custom v-slot="{ navigate, href, isActive }">
                <li class="nav-item" :class="{ 'nav-item-active': isActive }">
                  <a class="nav-link" :href="href" @click="navigate">{{ $t('nav.help') }}</a>
                </li>
              </router-link>
            </ul>
          </div>
          <div class="user-menu flex">
            <router-link :to="'/user/'+user.id+'/'" class="user-name flex" :title="user.fio">
              <div class="user-icon">
                <svg class="svg-user">
                  <use href="/img/sprite.svg#svg-user"></use>
                </svg>
              </div>
              <p>{{ user.fio }}</p>
            </router-link>
            <div class="user-role label txt-upper">
              <span class="font-11"> {{ user.role_name=='Поставщик'?'Supplier':user.role_name }}</span>
            </div>
            <div class="user-exit flex">
              <span class="exit-icon">
                <svg class="svg-exit">
                  <use href="/img/sprite.svg#svg-exit"></use>
                </svg>
              </span>
              <span @click="logoutFromAccount" class="font-15">{{ $t('nav.logout') }}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main class="main-page" :class="{'main-page--compact': isCompactTablePage}">
      <div class="container" :class="{'container-1200': narrow}">
        <router-view/>
      </div>
    </main>
    <footer class="footer">
      <div class="container">
        <p class="font-16 txt-center">{{ $t('footer.copyright') }}</p>
      </div>
    </footer>
  </div>

  <button
    v-if="showScrollTop"
    class="scroll-top-btn"
    type="button"
    :aria-label="$t('app.scrollTop')"
    :title="$t('app.top')"
    @click="scrollToTop"
  >
    <svg class="scroll-top-btn__icon" aria-hidden="true">
      <use href="/img/sprite.svg#svg-up"></use>
    </svg>
  </button>

  <Notify></Notify>
  <UnreadOrderMessage v-if="user.role === 'supplier'"></UnreadOrderMessage>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Notify from '@/components/Notify.vue';
import UnreadOrderMessage from '@/components/order/UnreadOrderMessage.vue';

export default {
  data: () => ({
    showScrollTop: false
  }),
  components: {
    Notify,
    UnreadOrderMessage
  },
  created() {

  },
  mounted() {
    this.handleScrollTopVisibility();
    window.addEventListener('scroll', this.handleScrollTopVisibility, {passive: true});
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScrollTopVisibility);
  },
  computed: {
    ...mapGetters([
      'isAuth',
      'user',
      'lang'
    ]),
    ...mapGetters('app', [
      'helpSettings'
    ]),

    title() {
      return this.$route.meta.name;
    },
    currentHelpSettings() {
      return this.helpSettings[this.lang] || {};
    },
    isMain() {
      return this.$route.meta.main_page;
    },
    narrow() {
      return this.$route.meta.narrow_page;
    },
    isCompactTablePage() {
      return ['main', 'orders-completed', 'order', 'position'].includes(this.$route.name);
    }
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    prevPage() {
      this.$router.go(-1)
    },
    handleScrollTopVisibility() {
      this.showScrollTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    async logoutFromAccount() {
      await this.logout();
      this.$router.push('/auth/');
    }
  },
}
</script>

<style scoped>
.scroll-top-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border: 0;
  border-radius: 50%;
  background: var(--biryuzovyy-400);
  color: var(--belyy);
  box-shadow: 0 7px 20px 0 rgba(59, 109, 113, 0.22);
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.scroll-top-btn:hover,
.scroll-top-btn:focus-visible {
  background: var(--biryuzovyy-300);
  box-shadow: 0 10px 26px 0 rgba(59, 109, 113, 0.28);
  transform: translateY(-2px);
}

.scroll-top-btn:focus-visible {
  outline: 2px solid var(--biryuzovyy-300);
  outline-offset: 3px;
}

.scroll-top-btn__icon {
  width: 16px;
  height: 20px;
}

@media (max-width: 767px) {
  .scroll-top-btn {
    right: 16px;
    bottom: 16px;
    width: 46px;
    height: 46px;
  }
}
</style>
